<div [class.loading-mask]="isLoading">
  <ng-content></ng-content>
</div>
